import React, { useState } from "react";
import { GetPaymentDisbursementHistoryResponse } from "../../types/api/user";
import i18n from "../../i18n/config";
import { useSelector } from "react-redux";
import { RootState } from "../../types/redux";
import { FORM_NAMES } from "../../constants/forms";

import PageBlock from "../../components/Layouts/PageBlock";
import FlowScreen from "../../components/Layouts/FlowScreen";
import SearchForm from "../../components/PaymentDisbursementHistory/SearchForm";
import ResultsTable from "../../components/PaymentDisbursementHistory/ResultsTable";
import Pagination from "../../components/Common/Pagination";
import ApiErrorModal from "../../components/Common/Modals/ApiErrorModal";

const PaymentDisbursementHistory = () => {
  const [searchParams, setSearchParams] = useState({
    page: 1,
    sortOrder: 1,
    sortColumn: "DateTime",
    submitSearch: false
  });
  const [submitting, setSubmitting] = useState(true);
  const [results, setResults] = useState<GetPaymentDisbursementHistoryResponse | null>(null);
  const values = useSelector((state: RootState) => state?.form?.[FORM_NAMES.PAYMENT_DISBURSEMENT_HISTORY]?.values);

  const setPageNumber = (newPageNumber: number) => {
    setSearchParams({
      ...searchParams,
      page: newPageNumber,
      submitSearch: true
    })
  }

  return (
    <FlowScreen flowTitle={i18n.t("PAGES.PAYMENTS.TITLE")} className="max-width-full" showBackButton={true}>
      <PageBlock>
        <PageBlock.Title>
          {i18n.t("PAGES.PAYMENTS.SUBTITLE")}
        </PageBlock.Title>
        <PageBlock.Body>
          <SearchForm
            setResults={setResults}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            setSubmitting={setSubmitting}
          />
        </PageBlock.Body>
      </PageBlock>

      <ResultsTable
        results={results}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        submitting={submitting}
      />

      {(results?.totalCount ?? 0) > 0 &&
        <Pagination
          totalCount={results!.totalCount}
          currentPage={searchParams.page}
          itemsPerPage={Number(values.pageSize)}
          updateCurrentPage={setPageNumber}
        />
      }

      <ApiErrorModal />

    </FlowScreen>
  );
}

export default PaymentDisbursementHistory;